import { render, staticRenderFns } from "./Blackstory.vue?vue&type=template&id=bbcd3ccc&scoped=true&"
import script from "./Blackstory.vue?vue&type=script&lang=js&"
export * from "./Blackstory.vue?vue&type=script&lang=js&"
import style0 from "./Blackstory.vue?vue&type=style&index=0&id=bbcd3ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcd3ccc",
  null
  
)

export default component.exports